import { render } from "./Race82.vue?vue&type=template&id=4235847c&scoped=true"
import script from "./Race82.vue?vue&type=script&lang=js"
export * from "./Race82.vue?vue&type=script&lang=js"

import "./Race82.vue?vue&type=style&index=0&id=4235847c&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4235847c"]])

export default __exports__